import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import { Helmet } from 'react-helmet'
import { Layout } from '../components/common'
import { MetaData } from '../components/common/meta'
import { SubscribeForm } from '../components/common'
/**
* Main index page (home page)
*
* Loads all posts from Ghost and uses pagination to navigate through them.
* The number of posts that should appear per page can be setup
* in /utils/siteConfig.js under `postsPerPage`.
*
*/
const getTitle = t => {
    var title = ""
    if (t.search("#") > -1) {
        title = t.split("#")[1]
    } else {
        title = t
    }

    return title
}

const Index = ({ data, location, pageContext }) => {
    //const posts = data.allGhostPost.edges
    //const page = data.ghostPage

    var pages = data.allGhostPage.edges
    // var hPage = pages.filter(({ node }) => {
    //     if (node.tags.some(x => x.slug === "hash-hpage")) {
    //         return node
    //     }
    // })

    var gridPage = pages.filter(({ node }) => {
        if (node.tags.some(x => x.slug === "hash-home")) {
            return node
        }
    })

    var grids2cPage = gridPage.filter(({ node }) => {
        if (node.tags.some(x => x.slug === "hash-s2c")) {
            return node
        }
    })

    gridPage = gridPage.sort((a, b) => {
        let fa = parseInt(a.node.title.split("#")[0]),
            fb = parseInt(b.node.title.split("#")[0]);

        if (fa < fb) {
            return -1;
        }
        if (fa > fb) {
            return 1;
        }
        return 0;
    })

    return (
        <>
            <MetaData location={location} />
            <Layout isHome={true} bodyClass="home">
                <div className="container">

                    <header className="author-header">
                        <div className="author-header-content">
                            <div className="author-header-meta">
                                <a key={`ahilink-x`} className="author-header-item-sel" href="/" >Overview</a>
                                {/* {hPage.sort((a, b) => {
                                    let fa = parseInt(a.node.title.split("#")[0]),
                                        fb = parseInt(b.node.title.split("#")[0]);

                                    if (fa < fb) {
                                        return -1;
                                    }
                                    if (fa > fb) {
                                        return 1;
                                    }
                                    return 0;
                                }).map(({ node }, k) => (
                                    <a key={`ahilink-${k}`} className="author-header-item" href={`/${node.slug}`} >{getTitle(node.title)}</a>
                                ))} */}
                                
                                {grids2cPage.sort((a, b) => {
                                    let fa = parseInt(a.node.title.split("#")[0]),
                                        fb = parseInt(b.node.title.split("#")[0]);

                                    if (fa < fb) {
                                        return -1;
                                    }
                                    if (fa > fb) {
                                        return 1;
                                    }
                                    return 0;
                                }).map(({ node }, k) => (
                                    <a key={`ahilink-${k}`} className="author-header-item" href={`/#${node.slug}`} >{getTitle(node.title)}</a>
                                ))}
                            </div>
                        </div>
                    </header>

                </div>
                <div className="container homeTemplate">

                    {gridPage.map(({ node }, index) => {
                        
                        return (
                            <>
                                <Helmet>
                                    <style type="text/css" id={`s-${node.slug}`} >{`${node.codeinjection_head}`}</style>
                                </Helmet>
                                {(index == 0) ? <section data-name={node.title} id={`${getTitle(node.slug)}`} key={`hi-${node.slug}-${index}`} className={`content-body load-external-scripts home-item home-item${index}`}><section dangerouslySetInnerHTML={{ __html: node.html }} /><SubscribeForm /></section> : <section data-name={node.title} id={`${getTitle(node.slug)}`} key={`hi-${node.slug}-${index}`} className={`content-body load-external-scripts home-item home-item${index}`} dangerouslySetInnerHTML={{ __html: node.html }} />}
                            </>
                        )

                    })}

                </div>
            </Layout>
        </>
    )
}

Index.propTypes = {
    data: PropTypes.shape({
        allGhostPost: PropTypes.object.isRequired,
    }).isRequired,
    location: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
    }).isRequired,
    pageContext: PropTypes.object,
}

export default Index

// This page query loads all posts sorted descending by published date
// The `limit` and `skip` values are used for pagination
export const pageQuery = graphql`
  query GhostPostQuery($limit: Int!, $skip: Int!) {
    allGhostPost(
        sort: { order: DESC, fields: [published_at] },
        limit: $limit,
        skip: $skip
    ) {
      edges {
        node {
          ...GhostPostFields
        }
      }
    }
    allGhostPage(filter: {tags: {elemMatch: {slug: {in: ["hash-home", "hash-hpage"]}}}}) {
        edges {
          node {
            ...GhostPageFields
          }
        }
    }
  }
`
